import { Avatar, Button, Card, Col, Popover, Row, Space, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useState } from 'react';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { PlusOutlined, InfoOutlined, HddOutlined } from '@ant-design/icons';
import { useAuth } from '../../Context';
import { useEffect } from 'react';
import FieldLithologyCrud from './crud';

const { Title } = Typography;

export default function FieldLithology () {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	useAuth();

	const [openModal, setOpenModal] = useState(false);

	const handleOpenAddModal = () => {
		setOpenModal(true);
	};


	useEffect(() => {
		window.scrollTo(0, 0);
	},[]);

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}>{ langdata && langdata.fieldLithologyManagementContent ? langdata.fieldLithologyManagementContent : 'This section of the dashboard is designed to manage and visualize the different lithological layers present in various well fields. Lithology refers to the physical characteristics of the rock layers, such as composition, grain size, and structure, \
			 which play a crucial role in oil exploration and production. By categorizing wells based on their lithological profiles, this module enables better field segmentation, improved reservoir analysis, and more accurate decision-making for drilling and extraction strategies.'}</p>
		</Card>
	);	

	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<HddOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.FieldLithologyManagement ? langdata.FieldLithologyManagement : 'Field Lithology Management'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={handleOpenAddModal} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;</Space>
							<Space>
								<Typography>
									<Popover title={ langdata && langdata.FieldLithologyManagement ? langdata.FieldLithologyManagement : 'Field Lithology Management'}  content={infoContent} trigger="click">
										<Avatar size="small"><InfoOutlined /></Avatar>
									</Popover>
								</Typography>
							</Space>
						</Col>
					</Row>
				</Col>
			</Row>
			<FieldLithologyCrud modal = {openModal} setOpenModal = {setOpenModal}/>
		</Content>
	);
}